// import _vue from '@/main'
import axios from 'axios';
// import {Modal,Message} from 'view-design'
axios.defaults.timeout = 120000;

//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': localStorage.getItem('token'),
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.errCode == 2) {
      // router.push({
      //   path:"/login",
      //   querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      // })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, baseURL) {
  axios.defaults.baseURL = window.g[baseURL];
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        if (response.data.success == 0) {
          reject(response.data.error)
          if (response.data.error == "缺少token授权参数" || response.data.error == "无token，请重新登录" || response.data.error == "token信息异常,无法解析" || response.data.error == "用户不存在，请重新登录" || response.data.error == "用户登录信息过期,请重新登录") {
            // Modal.warning({
            //   title: '提示',
            //   content: '登陆过期，请重新登录！',
            //   onOk:function(){
            //     _vue.$router.push({path:'/'})
            //     localStorage.clear();//清除本地缓存
            //     sessionStorage.clear();//清除本地缓存
            //     setTimeout(function(){
            //       location.reload();
            //     },500)

            //   }
            // });
          } else {
            // Message.error({
            //   background:true,
            //   content: response.data.error,
            // });
            
          }
        } else {
          resolve(response.data.data);
        }

      }).catch(error => {
          reject(error)
    })
  })
}

/**
* 封装patch请求
* @param url
* @param data
* @returns {Promise}
*/

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
* 封装put请求
* @param url
* @param data
* @returns {Promise}
*/

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}